import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, NgModule } from '@angular/core';
import { MatSnackBarModule, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ErrorTemplatesModule } from '@app/components/error-templates/error-templates.component';

@Component({
  selector: 'app-alert-templates',
  templateUrl: './alert-templates.component.html',
  styleUrls: ['./alert-templates.component.scss']
})
export class AlertTemplatesComponent {

  public static readonly interestssyncing = 'interestssyncing';
  public static readonly interestsselectionupdated = 'interestsselectionupdated';
  public static readonly languageselectionupdated = 'languageselectionupdated';
  public static readonly interestsselectionsynced = 'interestsselectionsynced';
  public static readonly updatedorder = 'updatedorder';
  public static readonly newssettingsupdated = 'newssettingsupdated';
  public static readonly tabconfigupdated = 'tabconfigupdated';
  public static readonly channelcachecleared = 'channelcachecleared';
  public static readonly operationcompleted = 'operationcompleted';
  public static readonly updatedsetting = 'updatedsetting';
  public static readonly genericupdated = 'genericupdated';
  public static readonly genericadded = 'genericadded';
  public static readonly genericdeleted = 'genericdeleted';
  public static readonly unlicensed = 'unlicensed';
  public static readonly offline = 'offline';
  componentName = '';
  errorCode: number ;
  errorInfo: HttpErrorResponse;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  isNumber(val) {
    this.errorInfo = val.error && val.error;
    const errorInfo = val.id.includes(';') ? val.id.split(';') : val.id;
    if (errorInfo.length === 2) {
      this.errorCode = +errorInfo[0];
      this.componentName = errorInfo[1];
    } else {
      this.errorCode = errorInfo;
    }
    return typeof this.errorCode === 'number';
  }

}
@NgModule({
  declarations: [AlertTemplatesComponent],
  entryComponents: [AlertTemplatesComponent],
  imports: [
    CommonModule,
    ErrorTemplatesModule,
    MatSnackBarModule
  ]
})
export class AlertTemplatesModule { }
